import { Fragment } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { privateRoutes, publicRoutes } from './config';
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './ProtectedRoutes';

const Router = () => {
  return (
    <Fragment>
      <Routes>
        <Route path='*' element={<Navigate to='/' />} />
        <Route element={<PrivateRoutes />}>
          {privateRoutes.map((route, index) => {
            return (
              <Route path={route.path} element={route.element} key={index} />
            );
          })}
        </Route>
        <Route element={<PublicRoutes />}>
          {publicRoutes.map((route, index) => {
            return (
              <Route path={route.path} element={route.element} key={index} />
            );
          })}
        </Route>
      </Routes>
    </Fragment>
  );
};

export default Router;
